import {
  REPORT_DOWNLOAD,
  REPORT_DOWNLOAD_FAIL,
  REPORT_DOWNLOAD_RESET,
  REPORT_DOWNLOAD_SUCCESS,
  REPORT_EXPORT,
  REPORT_EXPORT_FAIL,
  REPORT_EXPORT_RESET,
  REPORT_EXPORT_SUCCESS,
  REPORT_LIST,
  REPORT_LIST_COLUMN,
  REPORT_LIST_FAIL,
  REPORT_LIST_RESET,
  REPORT_LIST_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  // List Report
  list: {
    items: [],
    totalCount: 0,
    columnsVisible: null,
    params: {
      sizePerPage: 10,
      page: 1,
      sort: "-maker_date",
      columnFilter: {}, // Column filter
      keywords: "", // Input search all
    },
  },
  loadingList: false,
  errorList: null,

  // Export Report
  export: null,
  loadingExport: false,
  errorExport: null,

  // Download Report
  download: null,
  loadingDownload: false,
  errorDownload: null,
};

const reportManagement = (state = INIT_STATE, action) => {
  switch (action.type) {
    // List Report
    case REPORT_LIST:
      return {
        ...state,
        loadingList: true,
        errorList: null,
      };
    case REPORT_LIST_SUCCESS:
      return {
        ...state,
        errorList: null,
        loadingList: false,
        list: {
          ...state.list,
          items: action.payload.items,
          totalCount: action.payload._meta
            ? action.payload._meta.totalCount
            : action.payload.items.length,
        },
      };
    case REPORT_LIST_FAIL:
      return { ...state, loadingList: false, errorList: action.payload };
    case REPORT_LIST_RESET:
      return {
        ...state,
        loadingList: false,
        errorList: null,
        list: {
          ...state.list, // columnsVisible
          items: [],
          totalCount: 0,
          params: {
            sizePerPage: 10,
            page: 1,
            sort: "-maker_date",
            columnFilter: {},
            keywords: "",
          },
        },
      };
    case REPORT_LIST_COLUMN:
      const currentColumns = state.list.columnsVisible || {};
      currentColumns[action.payload.field] = action.payload.value;
      return {
        ...state,
        list: { ...state.list, columnsVisible: currentColumns },
      };

    // Export Report
    case REPORT_EXPORT:
      return {
        ...state,
        loadingExport: true,
        errorExport: null,
      };
    case REPORT_EXPORT_SUCCESS:
      return {
        ...state,
        loadingExport: false,
        errorExport: null,
        export: { ...action.payload, success: true },
      };
    case REPORT_EXPORT_FAIL:
      return { ...state, loadingExport: false, errorExport: action.payload };
    case REPORT_EXPORT_RESET:
      return {
        ...state,
        loadingExport: false,
        errorExport: null,
        export: null,
      };

    // Download Report
    case REPORT_DOWNLOAD:
      return {
        ...state,
        loadingDownload: true,
        errorDownload: null,
      };
    case REPORT_DOWNLOAD_SUCCESS:
      return {
        ...state,
        loadingDownload: false,
        errorDownload: null,
        download: { ...action.payload, success: true },
      };
    case REPORT_DOWNLOAD_FAIL:
      return {
        ...state,
        loadingDownload: false,
        errorDownload: action.payload,
      };
    case REPORT_DOWNLOAD_RESET:
      return {
        ...state,
        loadingDownload: false,
        errorDownload: null,
        download: null,
      };

    default:
      return state;
  }
};

export default reportManagement;
